export default "__VITE_PUBLIC_ASSET__65eb83b6__"